import { Col, Divider, Radio, Row } from "antd";
import React, { useEffect, useState } from "react";
import mc from "../../../../../../assets/icons/mc.svg";
import qitaf from "../../../../../../assets/icons/qitaf.png";
import visa from "../../../../../../assets/icons/visa.svg";
import appel from "../../../../../../assets/icons/apple.svg";
import mada from "../../../../../../assets/icons/mada.svg";
import groupe from "../../../../../../assets/icons/groupe.svg";
import creditCard from "../../../../../../assets/icons/creditCard.svg";
import creditCard1 from "../../../../../../assets/icons/creditCard1.svg";
import creditCard2 from "../../../../../../assets/icons/creditCard2.svg";
import { AppDispatch, RootState } from "../../../../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getSponsorDetails,
  getSponsoredOrphans,
  getUnsponsoredOrphans,
  toAddBooking,
} from "../../../../../../apis/actions/sponsor.actions";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import MoyasarForm from "../../../../../../components/Moyasar/MoyasarForm";
import {
  setBookingLines,
  setDonationTypeId,
  setMobile,
} from "../../../../../../apis/slices/moyasarSlice";
import { showNotitfication } from "../../../../../../components/utils/utils";
import { handleBookingLines } from "../../utils";
import {
  setResModel,
  setResIds,
} from "../../../../../../apis/slices/ratingSlice";

interface Props {
  selectedItems: any[];
}
const UnsponsoredPaymentMethod = ({ selectedItems }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { sponsorshipAmount } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const [state, setState] = useState<any>({
    association_date: null,
    booking_date: null,
  });
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);
  const [selected, setSelected] = useState<number>(-1);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const openMoyasar = () => {
    setDisplayMoyasar(true);
    dispatch(setMobile(sponsor.mobile));
    dispatch(setBookingLines(booking_lines));
    dispatch(setDonationTypeId({ id: false, name: "كفالة" }));
    setSelected(1);
  };
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );

  useEffect(() => {
    setState({
      association_date: moment().add(
        sponsorshipAmount?.waiting_time_settlement_association_office,
        sponsorshipAmount?.association_office_period + "s"
      ),
      booking_date: moment().add(
        sponsorshipAmount?.waiting_time_settlement_electronic,
        sponsorshipAmount?.electronic_period + "s"
      ),
    });
  }, [sponsorshipAmount]);
  const [booking_lines, setbooking_lines] = useState<any[]>([]);
  useEffect(() => {
    setbooking_lines(handleBookingLines(selectedItems));
  }, [selectedItems]);
  const otpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const handleAddBooking = (booking_lines: any, type: any, index: number) => {
    if (isSubmitting) return;
    setSelected(index);
    setIsSubmitting(true);
    dispatch(
      toAddBooking({
        payment_method: type,
        sponsorship_booking_line_ids: booking_lines,
        sponsor_id: otpId,
      })
    ).then((res: any) => {
      const booking = res?.payload?.result;

      if (booking?.code === 200) {
        dispatch(setResModel(booking?.res_model));
        dispatch(setResIds([booking?.booking_request_id]));
        showNotitfication(booking?.message, "success", dispatch);
        dispatch(
          getUnsponsoredOrphans({
            limit: 8,
            page: 1,
            beneficiary_type: "",
            sponsorship_type: "",
          })
        );
        dispatch(getSponsoredOrphans({ sponsor_id: otpId }));
        dispatch(getSponsorDetails({ sponsor_id: OtpId }));
        setTimeout(() => {
          navigate("/profile", { state: { selectedKey: "s1" } });
        }, 3000);
      } else {
        showNotitfication(booking?.message, "error");
        setSelected(-1);
        setIsSubmitting(false);
      }
    });
  };
  return (
    <>
      <Row gutter={24} dir="rtl">
        <Col
          xxl={2}
          xl={2}
          lg={2}
          md={2}
          sm={2}
          xs={2}
          style={{ padding: "0" }}
        >
          <div className="takaful--payment-method-header-img">
            <img src={groupe} alt="" />
          </div>
        </Col>
        <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20}>
          <p className="takaful--payment-method-header-title takaful--commun-style">
            طريقة السداد
          </p>
        </Col>
      </Row>
      <Divider className="takaful--divider-method-payment" />
      <Row
        gutter={24}
        justify={"start"}
        dir="rtl"
        style={{ marginBottom: "1.5rem" }}
      >
        <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
          <Radio
            type="radio"
            className="takaful--radio-style"
            onClick={() => openMoyasar()}
            checked={selected === 1}
            disabled={isSubmitting}
          />
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
          <div className="takaful--payment-method-card-container">
            <img src={creditCard} alt="" />
          </div>
        </Col>
        <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={16}>
          <div className="takaful--payment-method-container ">
            <span className="takaful--commun-style">سداد فوري</span>
            <div className="takaful--donation-payment">
              <img
                className={`takaful--icon-btn takaful--icon-booking`}
                src={mada}
                alt=""
              />
              <img
                className={`takaful--icon-btn takaful--icon-booking`}
                src={mc}
                alt=""
              />
              <img
                className={`takaful--icon-btn takaful--icon-booking`}
                src={visa}
                alt=""
              />
              <img
                className={`takaful--icon-btn takaful--icon-booking`}
                src={appel}
                alt=""
              />
              <img
                className={`takaful--icon-btn takaful--icon-booking`}
                src={qitaf}
                alt=""
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row
        gutter={24}
        justify={"start"}
        dir="rtl"
        style={{ marginBottom: "1.5rem" }}
      >
        <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
          <Radio
            onClick={() => handleAddBooking(booking_lines, "electronic", 2)}
            type="radio"
            className="takaful--radio-style"
            checked={selected === 2}
            disabled={isSubmitting}
          />
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
          <div className="takaful--payment-method-card-container">
            <img src={creditCard1} alt="" />
          </div>
        </Col>
        <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={16}>
          <div className="takaful--payment-method-container">
            <span className="takaful--commun-style"> سداد مؤجل</span>
            <div className="takaful--donation-payment-desc takaful--commun-style">
              <p>
                {`لتجنب الإلغاء، يرجى إكمال الدفع قبل يوم ${state.booking_date
                  ?.locale("en")
                  .format("YYYY/MM/DD")} ${
                  sponsorshipAmount.electronic_period === "day"
                    ? ""
                    : "الساعة " +
                      state.booking_date?.locale("en").format("HH:MM")
                } `}
                يمكنك مراجعة على التنبيهات الدفع فورياً.
              </p>
            </div>
          </div>
        </Col>
      </Row>
      {sponsorshipAmount?.enable_payment_through_association === true && (
        <Row
          gutter={24}
          justify={"start"}
          dir="rtl"
          style={{ marginBottom: "1.5rem" }}
        >
          <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2}>
            <Radio
              onClick={() =>
                handleAddBooking(booking_lines, "association_office_payment", 3)
              }
              checked={selected === 3}
              type="radio"
              className="takaful--radio-style"
              disabled={isSubmitting}
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
            <div className="takaful--payment-method-card-container">
              <img src={creditCard2} alt="" />
            </div>
          </Col>
          <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={16}>
            <div className="takaful--payment-method-container">
              <span className="takaful--commun-style">في مقر الجمعيّة</span>
              <div className="takaful--donation-payment-desc takaful--commun-style takaful--association-payment">
                <p>{`سيتم الغاء الطلب في حال عدم السداد قبل ${state.association_date
                  ?.locale("en")
                  .format("YYYY/MM/DD")} ${
                  sponsorshipAmount.association_office_period === "day"
                    ? ""
                    : "الساعة " +
                      state.association_date?.locale("en").format("HH:MM")
                } `}</p>
              </div>
            </div>
          </Col>
        </Row>
      )}
      <MoyasarForm
        amount={selectedItems.reduce((a, b) => b.amount + a, 0)}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => {
          setDisplayMoyasar(false);
          dispatch(setBookingLines([]));
        }}
      />
    </>
  );
};

export default UnsponsoredPaymentMethod;
